exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".load-more-container--1NqkQ{margin-top:14px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.no-more-Load--3mpdj{visibility:hidden}\n", "", {"version":3,"sources":["/workspace/src/widget/event_layouts/pagination_container.scss"],"names":[],"mappings":"AAAA,4BACE,gBACA,oBAAA,oBAAA,aACA,wBAAA,qBAAA,sBAAuB,CACxB,qBAGC,iBAAkB,CAAA","file":"pagination_container.scss","sourcesContent":[".load-more-container {\n  margin-top: 14px;\n  display: flex;\n  justify-content: center;\n}\n\n.no-more-Load {\n  visibility: hidden;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"load-more-container": "load-more-container--1NqkQ",
	"loadMoreContainer": "load-more-container--1NqkQ",
	"no-more-Load": "no-more-Load--3mpdj",
	"noMoreLoad": "no-more-Load--3mpdj"
};